/* eslint-disable no-underscore-dangle */
import { BetweenShiftService } from './../between-shift.service';
import { LocalNotificationService } from '../../local-notification.service';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SettingsService } from 'src/app/settings/settings.service';
import { ShiftDetectionService } from '../shift-detection.service';
import { take, tap } from 'rxjs/operators';
import { Preferences } from '@capacitor/preferences';

@Injectable({
  providedIn: 'root'
})
export class SitTimersService {

  elapsedTime = 0;
  started = false;
  timeString: string;

  private sittingInterval: any;
  private _sitTimer = new Subject<number>();
  private isShiftDetecting = false;

  constructor(
    private localNotificationService: LocalNotificationService,
    private shiftDetectionService: ShiftDetectionService,
    private betweenShiftService: BetweenShiftService
    ) { }

  get sitTimerObs() {
    return this._sitTimer.asObservable();
  }

  setNotifications(startTime: string, interval: number) {
    if (SettingsService.settings.showNotifications) {
      this.localNotificationService.setAllDayNotifications(+startTime, interval);
    }
  }

  startSitPeriodTimer(startTime: string, interval: number, seconds: number) {
    if (this.sittingInterval) {
      clearInterval(this.sittingInterval);
    }
    //set up notifications
    if (SettingsService.settings.showNotifications && !SettingsService.settings.showSettings.isHeadless) {
      //introduce a 30 second wait time to allow notification to be sent before resetting all notifications
      setTimeout(() => {
            this.localNotificationService.setAllDayNotifications(+startTime, interval);
        }, 30000);
    } else {
      this.localNotificationService.clearReminderNotifications();
    }
    //const source = timer(0, 1000);
    let prevTickTimestamp = Date.now();
    this.sittingInterval = setInterval(async () => {
      const currentTickTimestamp = Date.now();
      const delta = currentTickTimestamp - prevTickTimestamp;
      prevTickTimestamp = currentTickTimestamp;
      seconds += Math.round(delta / 1000);
      //only show alert if not activelty shift detected or out of chair
      this.shiftDetectionService.isSActivityDetectedObs.pipe(
        take(1),
        tap((isDetected) => {
          this.isShiftDetecting = isDetected;
        })
      ).subscribe();
      if (seconds >= interval && !this.isShiftDetecting) {
        // Finish sit, trigger a shift reminder
        clearInterval(this.sittingInterval);
        const start = this.setStartTime();


        const directionSuggestion = [];
        const periodPPI = await this.betweenShiftService.getPeriodPPI();
        if (periodPPI.frontPPI < periodPPI.backPPI) {
          directionSuggestion.push('front');
        } else {
          directionSuggestion.push('back');
        }
        if (periodPPI.leftPPI < periodPPI.rightPPI) {
          directionSuggestion.push('left');
        } else {
          directionSuggestion.push('right');
        }
        if (SettingsService.settings.showNotifications && !SettingsService.settings.showSettings.isHeadless) {
          this.localNotificationService.presentShiftReminderConfirm(directionSuggestion, periodPPI);
        }
        this.startSitPeriodTimer(start, SettingsService.settings.shiftInterval, 0);
      }
      this._sitTimer.next(seconds);
    }, 1000);
  }

  stopSitPeriodTimer() {
    if (this.sittingInterval) {
      clearInterval(this.sittingInterval);
    }
  }


setStartTime() {
  const timeString = new Date().getTime().toString();
  Preferences.set({ key: 'collection_start', value: timeString });
  return timeString;
}

getStartTime() {
  return Preferences.get({ key: 'collection_start' });
}

  async getElapsedSeconds() {
    let elapsedSeconds = 0;
    return await this.getStartTime().then((time) => {
      if(time && time.value)
      {
        const now = new Date().getTime();
        const startTime = +time.value;
        elapsedSeconds = Math.floor((now - startTime) / 1000);
        return elapsedSeconds;
      } else {
        return 0;
      }
    });
  }
}
